import { toast } from "react-toastify";

import {
  PatchOrganizationRequestBodyType,
  PatchOrganizationResponseBodyType,
} from "@intelligems/ig-types/functions/organizations/patch-organization";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { organizationDomainKey, organizationsKeys } from "../queryKeys";
import { ApiRequest } from "../types/api";

const patchOrganization = async (
  data: ApiRequest<PatchOrganizationRequestBodyType>
) => {
  const resp = await api.patch<PatchOrganizationResponseBodyType>(
    "/v2/organizations",
    data.body
  );
  return resp.data;
};

export const usePatchOrganization = () => {
  const queryClient = useQueryClient();
  return useMutation<
    PatchOrganizationResponseBodyType,
    Error,
    ApiRequest<PatchOrganizationRequestBodyType>,
    any
  >({
    mutationFn: async (data: ApiRequest<PatchOrganizationRequestBodyType>) =>
      patchOrganization(data),
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({
        queryKey: organizationDomainKey.one(data.org.id),
      });
      await queryClient.invalidateQueries({ queryKey: organizationsKeys.one });
      toast.success("Updated!");
    },
  });
};
